import classNames from "classnames";
import React, { useContext, FC } from "react";
import { Link } from "react-router-dom";
import { legalAndPrivacyLinks } from "../../constants/legalAndPrivacy";
import { LegalAndPrivacyContext } from "../../context/LegalAndPrivacyContext";
import { StateContext } from "../../context/stateContext";
import { useScreenWidth } from "../../hooks/useScreenWidth";
import utils from "../../utils/helperFunction";
import Select from "../select/Select";
import styles from "./legalPrivacyLeft.module.scss";
const LegalPrivacyLeft: FC = () => {
  const [screenWidth] = useScreenWidth();
  const { stateUSACode, languageCode } = useContext(StateContext);
  const { setCurrentPage, currentPage } = useContext(LegalAndPrivacyContext);
  const { uuid } = utils;

  const handleClick = (route: string) => {
    setCurrentPage(route);
  };
  const searchParams = new URLSearchParams(window.location.search);

  return (
    <>
      {screenWidth < 767 ? (
        <div className={styles.SelectMargin} data-testid="mob-select-dropdown">
          <Select links={legalAndPrivacyLinks(stateUSACode, languageCode)} />
        </div>
      ) : (
        legalAndPrivacyLinks(stateUSACode, languageCode).map(({ value, label }) => {
          searchParams.set("name", value);
          const link = searchParams.toString();
          return (
            <Link
              to={`?${link}`}
              key={uuid()}
              className={classNames(styles.Anchor, value === currentPage && styles.Active)}
              data-testid="listitem"
              onClick={() => handleClick(value)}
            >
              {label}
            </Link>
          );
        })
      )}
    </>
  );
};
export default LegalPrivacyLeft;
